document.addEventListener('DOMContentLoaded', function () {
  const toggleBtns = document.querySelectorAll('.wb-menu__item__language');

  toggleBtns.forEach((toggleBtn) => {
    const langSelector = toggleBtn.nextElementSibling;

    toggleBtn.addEventListener('click', function (event) {

      const isVisible = langSelector.style.display === 'block';

      // Toggle display
      langSelector.style.display = isVisible ? 'none' : 'block';

      // Trouve le dernier SVG dans le bouton
      const svgs = toggleBtn.querySelectorAll('svg');
      const lastSvg = svgs[svgs.length - 1];

      // Toggle rotation
      lastSvg.classList.toggle('rotate-180');

      // Update aria-expanded
      toggleBtn.setAttribute('aria-expanded', !isVisible);
    });
  });
});